/// <reference path="ListaEmpresas.js" />
/// <reference path="Configuracion.js" />


var oEventosPagInicial;

function GetObjEventosPagInicial() {
    if (oEventosPagInicial == undefined) {
        oEventosPagInicial = new ObjEventosPagInicial();
    }
    return oEventosPagInicial;
}

function ObjEventosPagInicial() {
    var that = this;


    this.cursorArriba = function () {
        window.scrollTo(0, 0);
    }

    this.inicializarCabeceraUI = function () {
        //console.log("Carga inicial ");

        that.PreparaScrollArriba();
        //$('#scrollAbajo').each(function () { alert("hola mundo abajo");})
        $('#scrollAbajo').bind("click", function () {
            //alert('kkabajo');
            var val = $(document).scrollTop() + 500;
            //alert(val);
            if (val >= $(document).heigh)
                $("html, body").animate({ scrollTop: $(document).heigh }, 200);
            else
                $("html, body").animate({ scrollTop: val }, 200);
            return false;
        });
        $('#scrollArriba').bind("click", function () {
            //alert('scrollArriba');
            var val = $(document).scrollTop() - 500;
            //alert(val);
            if (val < 0)
               $("html, body").animate({ scrollTop: 0 }, 200);
            else
               $("html, body").animate({ scrollTop: val }, 200);
            return false;
        });
        if ($("#menuDesplegable").css('display') == 'block') {
            $("#divAjusteMovil").show();
            //$('.capaCookies').css("height", "122px");
        }
        else {
            $("#divAjusteMovil").hide();
            //$('.capaCookies').css("height", "60px");
        }

        $(window).resize(function () {
            if ($("#menuDesplegable").css('display') == 'block') {
                $('#cabecera').css("padding-top", "80px");
            }
            else {
                $('#cabecera').css("padding-top", "0px");
            }
            if (!$('#contenedorMapas').is(':empty')) 
                GetMapa().RepintarMarcadores();
        });

        //Cuando presionan F5 cargamos la página inicial
        $("body").keydown(function (e) {
            //alert("keydown: " + e.which);
            //e.preventDefault();
            if (e.which == 116)
                GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO'); //window.location.hash = '#LEMPRESAS&p=1&t=TODO';
        });

        $('#formBusquedaNormal,#formBusquedaMovil').bind("keyup keypress", function (e) {
            var code = e.keyCode || e.which;
            if (code == 13) {
                e.preventDefault();
                return false;
            }
        });
        //$("#linkAviso").click(function (e) {
            //alert("Mostrar aviso legal");
            //$("#divAvisoLegal").css("display", "block");            
            //CatalogoWebUI.choosespanish();
        //});

        $("#idioEspanol").click(function (e) {
            //alert("español");
            CatalogoWebUI.choosespanish();
            GetObjControlador().saveAnalyticsOtros("CAMBIO IDIOMA", "Español");
        });

        $("#idioIngles").click(function (e) {
            //alert("Inglés");
            CatalogoWebUI.chooseenglish();
            GetObjControlador().saveAnalyticsOtros("CAMBIO IDIOMA", "Inglés");
        });

        $("#menuPrincipalExpositor").click(function (e) {
            e.preventDefault();
            CatalogoWebUI.setFlagOpcionElegida(false);
            CatalogoWebUI.setCriterioElegido("");
            GetObjListaEmpresas().limpiarFiltroPais();
            GetObjListaEmpresas().activarNumeroEmpresasFiltrar(GetObjConfiguracion().numEmpresas);
            GetObjControlador().navegarAPagina(GetObjConstantes()._LISTA, '#LEMPRESAS&p=1&t=TODO');
            //window.location.hash = '#LEMPRESAS&p=1&t=TODO';
        });
        $("#menuPrincipalFavoritos").click(function (e) {
            e.preventDefault();
            GetObjListaEmpresas().activarNumeroEmpresasFiltrarFavoritos("F_"+GetObjConfiguracion().numEmpresas);
            GetObjControlador().navegarAPagina(GetObjConstantes()._FAVORITOS, '#FAVORITOS&p=1');
            //window.location.hash = '#FAVORITOS&p=1';           
        });
        $("#menuPrincipalMapa").click(function (e) {
            e.preventDefault();
            GetFavoritos().MostrarFavoritos = true;
            GetObjControlador().navegarAPagina(GetObjConstantes()._MAPA_FERIA, '#MAPA_FERIA');
            //window.location.hash = '#MAPA_FERIA';
        });

    }

    this.loadCabecera = function () {
        $('#cabeceraFeria').attr('src', '../getrecurso.ashx?Feria=' + GetObjConfiguracion().feria + '&Tipo=R&Fichero=cabecera_feria_g.jpg');
    }

    this.setActivarOpcionMenu = function (opcionActual, opcionNueva) {

        //if (opcionActual != opcionNueva)
       // {
            that.ocultarOpcionAnterior(opcionActual);
            if (opcionNueva == 'F') {
                $("#menuPrincipalFavoritos").addClass("active");
                $("#contenedorFavoritos").css("display", "block");
                $("#txtOpcionMenuFavoritos").css("display", "block");
                GetObjConfiguracion().menuPrincipalActivo = 'F';
            }
            else {
                if (opcionNueva == 'E') {
                    $("#menuPrincipalExpositor").addClass("active");
                    $("#contenedorExpositores").css("display", "block");
                    $("#txtOpcionMenuExpositores").css("display", "block");
                    GetObjConfiguracion().menuPrincipalActivo = 'E';
                }
                else {
                    if (opcionNueva == 'M') {
                        $("#menuPrincipalMapa").addClass("active");
                        $("#contenedorMapas").css("display", "block");
                        $("#txtOpcionMenuMapa").css("display", "block");
                        GetObjConfiguracion().menuPrincipalActivo = 'M';
                    }
                    else {
                        if (opcionNueva == 'D') {
                            //$("#menuPrincipalMapa").addClass("active");
                            $("#contenedorFicha").css("display", "block");
                            $("#txtOpcionMenuFicha").css("display", "block");
                            GetObjConfiguracion().menuPrincipalActivo = 'D';
                        }
                    }
                }
            }
        //}
    }

    this.ocultarOpcionAnterior = function (opcionActual) {
        if (opcionActual == 'E') {
            $("#menuPrincipalExpositor").removeClass("active");
            $("#contenedorExpositores").css("display", "none");
            $("#txtOpcionMenuExpositores").css("display", "none");
        }
        if (opcionActual == 'F') {
            $("#menuPrincipalFavoritos").removeClass("active");
            $("#contenedorFavoritos").css("display", "none");
            $("#txtOpcionMenuFavoritos").css("display", "none");
        }
        if (opcionActual == 'M') {
            $("#menuPrincipalMapa").removeClass("active");
            $("#contenedorMapas").css("display", "none");
            $("#txtOpcionMenuMapa").css("display", "none");
        }
        if (opcionActual == 'D') {
            //$("#menuPrincipalMapa").removeClass("active");
            //$("#contenedorMapas").css("display", "none");
            $("#txtOpcionMenuFicha").css("display", "none");
        }
        //$(opcionmenu).addClass("active");
        $("#contenedorFicha").hide();
    }
    this.PreparaScrollArriba = function () {
        //<![CDATA[
        // Botón para Ir Arriba
        $(function () {
            $(window).scroll(function () {
                if ($(this).scrollTop() > 450) {
                    $('#IrArriba').fadeIn();
                } else {
                    $('#IrArriba').fadeOut();
                }
            });
            $('#IrArriba a').click(function () {
                $('body,html').animate({
                    scrollTop: 0
                }, 800);
                return false;
            });
        });


        //]]>
    }
};

ObjEventosPagInicial.prototype = {
    propiedad: ''
}